module.exports = __webpack_public_path__ + "static/img/img3.e10e5f9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/7/img3.png
// module id = lp2s
// module chunks = 0